import { WMX_PROMOTION_TYPE_CODE } from './constants';

export const isFivePercentWMXOffer = (promotionTypeCode: string, hidden?: boolean | null) => {
  return promotionTypeCode === WMX_PROMOTION_TYPE_CODE && !!hidden;
};
